import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../../apiConfig';
import { styled } from '@mui/system';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ShareIcon from '@mui/icons-material/Share';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

import NewsShowCaseModal from '../Modal/ItemShowCaseModal';
import ShareModal from '../Modal/ShareModal';

const NewsComplexCard = ({
  id,
  avatarText,
  avatarBgColor,
  actionIcon,
  title,
  subheader,
  image,
  content,
  style,
  layout = 'vertical',
  methodContent
}) => {
  const [selectedNews, setSelectedNews] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);

  const fetchNewsById = (id) => {
    axios.get(`${API_URL}/news/${id}`)
      .then((response) => {
        setSelectedNews(response.data);
      })
      .catch((error) => {
        console.error('Error fetching news information:', error);
      });
  };

  // Date formatting removed as requested

  const handleLearnMoreClick = () => {
    fetchNewsById(id);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleOpenShareModal = () => {
    setShareModalOpen(true);
  };

  const handleCloseShareModal = () => {
    setShareModalOpen(false);
  };

  const generateDynamicLink = (title) => {
    const formattedTitle = title.replace(/\s+/g, '-').toLowerCase();
    return `${API_URL}/news/${formattedTitle}-${id}`;
  };

  if (layout === 'horizontal') {
    return (
      <Paper elevation={3} style={{ display: 'flex', padding: '20px', borderRadius: '8px', width: '100%', ...style, transition: 'background-color 0.3s ease' }} sx={{ '&:hover': { bgcolor: 'grey.100' } }}>
        <Box style={{ width: '200px', height: '200px', marginRight: '20px', flexShrink: 0 }}>
          <CardMedia
            component="img"
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }}
            image={image}
            alt={title}
          />
        </Box>
        <Box style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Box>
            <Typography variant="h5" component="h2" style={{ marginBottom: '10px' }}>
              {title}
            </Typography>
            {/* Date removed as requested */}
            <Typography variant="body1" style={{ marginBottom: '15px' }}>
              {content && content.length > 150 ? `${content.slice(0, 150)}...` : content}
            </Typography>
          </Box>
          <CardActions style={{ paddingLeft: 0, paddingRight: 0, justifyContent: 'flex-start' }}>
            <IconButton aria-label="learn more" onClick={handleLearnMoreClick} sx={{ mr: 1 }}>
              <VisibilityIcon />
              <Typography variant="button" sx={{ ml: 0.5 }}>Learn More</Typography>
            </IconButton>
            <IconButton aria-label="share" onClick={handleOpenShareModal}>
              <ShareIcon />
              <Typography variant="button" sx={{ ml: 0.5 }}>Share</Typography>
            </IconButton>
          </CardActions>
        </Box>
        {selectedNews && (
          <NewsShowCaseModal
            open={modalOpen}
            onClose={handleCloseModal}
            title={selectedNews.title}
            longDescription={selectedNews.longDescription}
            file={selectedNews.imageURL || image}
          />
        )}
        <ShareModal
          open={shareModalOpen}
          onClose={handleCloseShareModal}
          link={generateDynamicLink(title)}
          id={id}
          isCalledFrom='news'
        />
      </Paper>
    );
  }

  return (
    <Card sx={{
      maxWidth: 345, 
      transition: 'background-color 0.3s ease',
      '&:hover': {
        bgcolor: 'grey.100' // MUI standard light gray
      },
      ...style 
      }}>
      <CardHeader
        sx={{
          height: 100,
          overflow: 'hidden',
          alignItems: 'flex-start'
        }}
        titleTypographyProps={{
          variant: 'h6',
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          },
        }}
        title={title}
        subheader={subheader}
      />
      <CardMedia
        component="img"
        height="194"
        image={image}
        alt={title || "News image"}
      />
      <CardContent sx={{ height: 100, overflow:"hidden" }}>
        <Typography variant="body2" color="text.secondary" sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
        }}>
          {content}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="learn more" onClick={handleLearnMoreClick}>
          <VisibilityIcon />
        </IconButton>
        <IconButton aria-label="share" onClick={handleOpenShareModal}>
          <ShareIcon />
        </IconButton>
      </CardActions>
      {selectedNews && (
        <NewsShowCaseModal
          open={modalOpen}
          onClose={handleCloseModal}
          title={selectedNews.title}
          longDescription={selectedNews.longDescription}
          file={selectedNews.imageURL || image}
        />
      )}
      <ShareModal
        open={shareModalOpen}
        onClose={handleCloseShareModal}
        link={generateDynamicLink(title)}
        id={id}
        isCalledFrom='news'
      />
    </Card>
  );
};

export default NewsComplexCard;
